<div class="Modal ModalTutorialExercito">
  <div class="HeaderModal">
    <div class="IconModal float-start">
      <span class="material-icons"> help_outline </span>
      <p>Como autorizar a consulta no SouGov.br?</p>
    </div>
    <span class="material-icons float-end CloseModal" (click)="closeModal()">
      close
    </span>
  </div>
  <img
    src="../../../../assets/image/modal-precp.png"
    class="w-100"
    alt="PRECP"
  />
  <div class="ModalContent">
    <h1 class="TtlModal">Qual é o seu PREC CP?</h1>
    <p class="TxtModal">
      Você encontra o número do PREC CP no canto superior esquerdo do
      contracheque. Se precisar, tire uma 2ª via do contracheque em
      <a class="txt-underline">www.cpex.eb.mil.br</a>.
    </p>
  </div>
</div>

